var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13V5l4 4zM16 18q.824 0 1.413-.587Q18 16.825 18 16V2q0-.824-.587-1.412A1.93 1.93 0 0 0 16 0H2Q1.176 0 .588.588A1.93 1.93 0 0 0 0 2v14q0 .824.588 1.413Q1.175 18 2 18zm-5-2H2V2h9z",
    fill: "#077ee0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpenIcon);
export default __webpack_public_path__ + "static/media/sidebar_open_icon.6bdf053e2c3a3d81f7e47a3663e7cc14.svg";
export { ForwardRef as ReactComponent };